import ApiClient from './ApiClient';

// Lista de supressão por telefone (Fase 4/LGPD): blacklist por conta.
// create({ phone_numbers: [...] }) -> insere em lote (POST campaign_suppressions).
class CampaignSuppressionsAPI extends ApiClient {
  constructor() {
    super('campaign_suppressions', { accountScoped: true });
  }
}

export default new CampaignSuppressionsAPI();
